import { FunctionComponent, useState } from 'react';
import clsx from 'clsx';
import { MarketplaceIntegrations } from '@spike/marketplace-model';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { useNonInitialEffect } from '@versiondos/hooks';
import { MarketplaceStatus } from '@spike/marketplace-action';
import { BusinessSettingsTitle } from '../UI';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { IntegrationCard } from './IntegrationCard';
import Quickbooks from './Quickbooks';
import Idogcam from './Idogcam';
import { IDOGCAM_ICON_SRC } from './Idogcam/model/IdogcamModel';
import styles from './Integrations.module.scss';

export interface Props {
    integrations?: MarketplaceIntegrations;
    onSave?: (integrations: MarketplaceIntegrations) => void;
    onContinue?: (integrations: MarketplaceIntegrations) => void;
    onChange?: (integrations: MarketplaceIntegrations) => void;
    className?: string;
    openSidebar?: () => void;
    isMobile?: boolean;
}

export const Integrations: FunctionComponent<Props> = props => {
    const [showQuickbooks, setShowQuickbooks] = useState(false);
    const [showIdogcam, setShowIdogcam] = useState(false);

    /*   const loading = useSelector<RootState, boolean>(state => state.marketplace.loading);
  const status = useSelector<RootState, MarketplaceStatus>(state => state.marketplace.status);
  const [saved, setSaved] = useState(false);

  const [integrations, setIntegrations] = useState({...props.integrations});

  useNonInitialEffect(() => {
    props.onChange && props.onChange(integrations);
    setSaved(_.isEqual(props.integrations, integrations));
  },[integrations]);

  useNonInitialEffect(() => {
    if(status === MarketplaceStatus.SaveSuccess || status === MarketplaceStatus.SaveSettingsMarketplaceSuccess) {
      setSaved(true);
    }
  },[status]); */

    /*   const changeValueHandler = (value: string) => {
    setIntegrations(prev => ({...prev, googleAnalyticsTrackingId: value}));
  };

  const clickButtonHandler = () => {
    props.onSave && props.onSave({ ...integrations });
    props.onContinue && props.onContinue({...integrations});
  }; */

    //const button = (<Button label={props.onSave ? (saved ? "Saved!" : "Save") : "Continue"} onClick={clickButtonHandler} loading={loading} />);

    const handleQuickBooksClick = () => {
        setShowQuickbooks(true);
    };

    const handleBackToIntegrations = () => {
        setShowQuickbooks(false);
        setShowIdogcam(false);
    };

    // The iDogCam screen handles both states: connect form or camera list.
    const handleIdogcamClick = () => {
        setShowIdogcam(true);
    };

    if (showIdogcam) {
        return <Idogcam onBack={handleBackToIntegrations} />;
    }

    if (showQuickbooks) {
        return (
            <Quickbooks
                openSidebar={props.openSidebar}
                isMobile={props.isMobile}
                onBack={handleBackToIntegrations}
                title="QuickBooks Integration"
                iconSrc="/images/settings/integrations/quickbooks.svg"
            />
        );
    }

    return (
        <div className={clsx(styles.container, props.className)}>
            <div className={styles.titleContainer}>
                <BusinessSettingsTitle className={styles.businessSettingsTittle}>
                    {' '}
                    {props.isMobile && (
                        <FontAwesomeIcon
                            className={styles.iconBusinessTitle}
                            onClick={props.openSidebar}
                            icon={faArrowLeft}
                            size="2x"
                        />
                    )}{' '}
                    Integrations
                </BusinessSettingsTitle>
            </div>
            <div className={styles.integrationsContainer}>
                <IntegrationCard
                    icon="/images/settings/integrations/quickbooks.svg"
                    title="QuickBooks"
                    description="Export your financial data to QuickBooks in a compatible CSV format."
                    onViewClick={handleQuickBooksClick}
                />
                <IntegrationCard
                    icon={IDOGCAM_ICON_SRC}
                    iconShape="wide"
                    title="iDogCam"
                    description="Manage all your business cameras from one dashboard. Monitor your space in real time."
                    onViewClick={handleIdogcamClick}
                />
            </div>
            {/* <div className={styles.nameContainer}>
        <TextField
          label="Google Analitycs Tracking ID"
          value={!isEmpty(integrations.googleAnalyticsTrackingId) ? integrations.googleAnalyticsTrackingId! : ""}
          onChange={changeValueHandler}
        />
      </div>
      <div className={clsx(styles.buttonContainer,{[styles.right]:props.onContinue})}>
        {button}
      </div> */}
        </div>
    );
};

export default Integrations;
